import { render, staticRenderFns } from "./DevDialog.vue?vue&type=template&id=7967cb3a&scoped=true"
import script from "./DevDialog.vue?vue&type=script&lang=js"
export * from "./DevDialog.vue?vue&type=script&lang=js"
import style0 from "./DevDialog.vue?vue&type=style&index=0&id=7967cb3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7967cb3a",
  null
  
)

export default component.exports